var _defs, _rect, _line, _line2, _line3, _line4, _circle, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgButtonshow01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 423 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-38,.cls-37,.cls-36,.cls-35{fill:#fff;}.cls-37,.cls-36,.cls-35{stroke:#000;stroke-miterlimit:10;}.cls-37{stroke-width:2.99px;}.cls-36{stroke-width:0.95px;stroke-dasharray:3.74;}.cls-35{stroke-width:1.03px;stroke-dasharray:4.03;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 147.81,
    y: 106.33,
    width: 133.18,
    height: 278.17
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 147.81,
    y1: 384.9,
    x2: 147.81,
    y2: 106.33
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-37",
    x1: 280.99,
    y1: 106.33,
    x2: 280.99,
    y2: 384.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-36",
    x1: 151.14,
    y1: 384.9,
    x2: 151.14,
    y2: 106.33
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-35",
    x1: 277.66,
    y1: 106.33,
    x2: 277.66,
    y2: 387.67
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 218.45,
    cy: 225.9,
    r: 22.11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 215.78,
    y: 197.75,
    width: 5.33,
    height: 56.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonshow01);
export default __webpack_public_path__ + "static/media/BUTTON SHOW-01.101d82a8a7975565738ce4e51a850113.svg";
export { ForwardRef as ReactComponent };